import { createFeature, createReducer, on } from '@ngrx/store';

import { Content } from '@mobi/oiv-viewer-utils-ng-jslib';
import { OIV_TYPE } from '@mobi/oiv-viewer-xml-parser-ng-jslib';
import { LoadingState } from '@mobi/rwc-uxframework-ng';

import { Avb, Index } from '../../../../share/model/atomic-model';

import { oivViewerActions } from './oiv-viewer.actions';

export interface AvbState {
    avbMetadata: Avb;
    avbChapters: Content[];
    avbCoverSheet: Content;
    index: Index;
    loadingError: boolean;
    loadingFeaturesError: boolean;
    loadingIndex: LoadingState;
    features: string[];
}

const initialState: AvbState = {
    avbMetadata: {
        language: 'de',
        textReference: '',
        contentVersion: '',
        urlName: '',
        censhareId: 0,
    },
    avbCoverSheet: {
        eId: '',
        type: OIV_TYPE.INFO,
        content: '',
    },
    avbChapters: [],
    index: {
        applicationId: '',
        indexId: '',
        searchOnlyApiKey: '',
        textReference: '',
        language: '',
        urlName: '',
    },
    loadingError: false,
    loadingFeaturesError: false,
    loadingIndex: LoadingState.LOADING,
    features: [],
};

export const oivViewerFeature = createFeature({
    name: 'oivViewer',
    reducer: createReducer<AvbState>(
        initialState,
        on(oivViewerActions.load, state => ({ ...state, loadingError: false })),
        on(oivViewerActions.loaded, (state, { avbMetadata, avbChapters, avbCoverSheet }) => {
            return {
                ...state,
                avbMetadata,
                avbChapters,
                avbCoverSheet,
                loadingError: false,
            };
        }),
        on(oivViewerActions.loadIndex, state => ({ ...state, loadingIndex: LoadingState.LOADING })),
        on(oivViewerActions.loadedIndex, (state, { index }) => {
            return {
                ...state,
                index,
                loadingIndex: LoadingState.READY,
            };
        }),
        on(oivViewerActions.loadIndexFailure, state => ({
            ...state,
            loadingIndex: LoadingState.ERROR,
        })),
        on(oivViewerActions.loadFailure, state => ({
            ...state,
            avbMetadata: { ...initialState.avbMetadata },
            avbChapters: [],
            loadingError: true,
        })),
        on(oivViewerActions.refresh, state => ({
            ...state,
            avbMetadata: { ...initialState.avbMetadata },
            avbChapters: [],
            loadingError: false,
        })),
        on(oivViewerActions.loadedFeatures, (state, { features }) => ({
            ...state,
            features: [...features],
        })),
        on(oivViewerActions.loadToggleFeaturesFailure, state => ({
            ...state,
            features: [],
            loadingFeaturesError: true,
        })),
    ),
});
